
export enum FormModeEnum {
	form = 'form',
	summary = 'summary',
}